import { lazyLoad } from "utils/loadable";

export const EmployerJobAppliedCandidate = lazyLoad(
  () => import("./index"),
  (module) => module.EmployerJobAppliedCandidate
);